import { BaseShaderMaterial } from 'ohzi-core';
import frag from '../shaders/wall/wall.frag';
import vert from '../shaders/wall/wall.vert';

export default class WallMaterial extends BaseShaderMaterial
{
  constructor()
  {
    super(vert, frag, {
      _MainTex: { value: undefined },
      _Opacity: { value: 0.8 },
      _Gradient: { value: 0 }
    });

    this.transparent = true;
  }

  set_texture(tex)
  {
    this.uniforms._MainTex.value = tex;
  }

  get opacity()
  {
    return this.uniforms._Opacity.value;
  }

  set opacity(val)
  {
    if (this.uniforms)
    {
      this.uniforms._Opacity.value = val;
    }
  }

  set_gradient(val)
  {
    this.uniforms._Gradient.value = val;
  }
}
